<script setup lang="ts">
import { PageName, SummaryInfo } from '@/api/tracking';
import { DgrCheckbox, DgrDialog, DgrIcon } from '@stockmarkteam/donguri-ui';
import { useFeedSummaryFeedback } from '@/components/feed-summary/composables/use-feed-summary-feedback';
import { FeedSummaryFeature } from '@/types';

const props = defineProps<{
  summaryInfo?: SummaryInfo;
  feature: FeedSummaryFeature;
  pageName: PageName;
}>();

const {
  isDialogOpen,
  dialogStatus,
  positiveFeedbacks,
  negativeFeedbacks,
  canSubmit,
  openDialog,
  submitFeedback,
} = useFeedSummaryFeedback(props);
</script>
<template>
  <div class="feedback">
    <button
      type="button"
      class="c-btn c-btn--auto c-btn--small c-outlineBtn--secondary"
      @click="openDialog('positive')"
      aria-label="役に立った"
      v-tooltip="{ content: '役に立った' }"
    >
      <DgrIcon name="thumbs-up" size="small" :keep-fill="false" />
    </button>
    <button
      type="button"
      class="c-btn c-btn--auto c-btn--small c-outlineBtn--secondary"
      @click="openDialog('negative')"
      aria-label="役に立たなかった"
      v-tooltip="{ content: '役に立たなかった' }"
    >
      <DgrIcon name="thumbs-down" size="small" :keep-fill="false" />
    </button>

    <DgrDialog v-model:open="isDialogOpen">
      <template #description>
        <h2 class="c-title-bold--xm">ご意見をお聞かせください</h2>
        <div class="subheader c-text-regular--s">
          いただいたフィードバックは、今後の改善に役立てさせていただきます
        </div>
        <div v-if="dialogStatus === 'positive'" class="feedback-options">
          <DgrCheckbox
            v-for="option in positiveFeedbacks"
            :key="option.id"
            :value="option.id"
            v-model="option.value"
            >{{ option.label }}</DgrCheckbox
          >
        </div>
        <div v-if="dialogStatus === 'negative'" class="feedback-options">
          <DgrCheckbox
            v-for="option in negativeFeedbacks"
            :key="option.id"
            :value="option.id"
            v-model="option.value"
            >{{ option.label }}</DgrCheckbox
          >
        </div>
      </template>
      <template #submit>
        <button
          class="c-btn c-btn--auto c-btn--AnewsPrimary"
          :class="{ disabled: !canSubmit }"
          :disabled="!canSubmit"
          @click="submitFeedback"
        >
          フィードバックを送信する
        </button>
      </template>
    </DgrDialog>
  </div>
</template>
<style lang="scss" scoped>
.feedback {
  display: flex;
  gap: 8px;

  button {
    border: none;
    padding: 8px;
    color: $color-gray800;

    &:not(:hover) {
      background: #fff;
    }
  }
}

h2 {
  margin-bottom: 4px;
}

.subheader {
  color: $color-gray600;
  margin-bottom: 16px;
}

.feedback-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
